// ===============================================================================
//
//  This file contains the class containing all the pathnames for Tasks
//
// ===============================================================================

export class TaskManagementComponentPaths {
    // ===============================================================================

    public static readonly BasePath: string = '/Tasks';

}